
import { Component, Vue } from 'vue-property-decorator'

/**
 * 部分ローディング表示
 *   ローディング表示させる部分に最後の子要素として使用する
 *   ページレベルのローディングと重複しないよう注意
 */
@Component
export default class TopicalLoading extends Vue {
  /** ローディング用画像 */
  private readonly loadingImage = require('@/assets/img/loading.png')

  /**
   * 画像のパス指定
   *
   * @returns style情報
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--image-path': `url(${this.loadingImage})`,
    }
  }
}
